<template>
    <div class="flex items-center">
         <span>{{ showDate(params.value) }}</span>
    </div>
</template>

<script>
const moment = require('moment-timezone');
export default {
  name: 'CellRendererCreateDate',
  methods: {
    showDate (date) {
        return moment(date,'YYYY-MM-DD HH:mm:ss').format('D MMM,YYYY HH:mm');
      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
